import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  @Output() clickOutSide = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: any){
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if(!clickedInside) {
      this.clickOutSide.emit();
    }
  }
}
